import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import User from "@/pcm/store/models/User";
import Creator from "@/pcm/store/models/Creator";

export default class CreatorNote extends Model {
    static entity = 'creator_notes';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            user_id: this.attr(null),
            creator_id: this.attr(null),
            content: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),

            user: this.belongsTo(User, 'user_id'),
            creator: this.belongsTo(Creator, 'creator_id'),
        }
    }

    declare id: number;
    declare content: string;
}
